module.exports = __webpack_public_path__ + "static/media/clock.0f20feea.0f20feea.png";